import { FlexBox } from "@braze/beacon-core";
import styled from "styled-components";

export const Background = styled(FlexBox)`
  background: url("img/braze-gradient.svg");
  background-blend-mode: multiply;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 99px;
  position: fixed;
  // height: 100%;
  // display: flex;
  // flex: 1;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: scroll;
  flex-direction: column;
  justify-content: center;
`;